<template>
  <!-- 各品牌标杆车型 市场实销趋势 -->
  <div>
    <!-- 查询年-1 市场实销 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="firstSearchDataTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
      >
        <!-- 市场实销 -->
        <el-table-column label="市场实销" align="center">
          <!-- 车型 -->
          <el-table-column
            prop="carModel"
            label="车型"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <!-- 查询年-1 -->
        <el-table-column
          :label="`${Number(queryParams.years) - 1}年`"
          align="center"
        >
          <!-- 实销 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.shixiaoField"
            :label="item.month"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <el-table-column
          prop="total"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{ getColumnTotal(scope.row, "total", "shixiaoField") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年 市场实销 -->
    <div class="table_container">
      <div class="table-btn" style="margin: 24px 0 12px 0">
        <el-button
          v-if="queryParams.years > 2024"
          :disabled="secondSearchDataTableData.length >= 15"
          type="primary"
          size="small"
          @click="handleAdd()"
          >添加</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="secondSearchDataTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <!-- 市场实销 -->
        <el-table-column label="市场实销" align="center">
          <!-- 车型 -->
          <el-table-column
            prop="carModel"
            label="车型"
            min-width="90px"
            align="center"
            :class-name="queryParams.years > 2024 ? '' : 'disabled_column'"
          >
            <template slot-scope="scope">
              <el-input
                v-if="
                  queryParams.years > 2024 &&
                    editField === 'carModel' &&
                    editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row.carModel"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              ></el-input>
              <div v-else>
                {{ scope.row.carModel }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- 查询年-1 -->
        <el-table-column
          :label="`${Number(queryParams.years)}年`"
          align="center"
        >
          <!-- 实销 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.shixiaoField"
            :label="item.month"
            min-width="90px"
            align="center"
            :class-name="queryParams.years > 2024 ? '' : 'disabled_column'"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  queryParams.years > 2024 &&
                    editField === item.shixiaoField &&
                    editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row[item.shixiaoField]"
                class="number_input"
                :controls="false"
                :precision="0"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row[item.shixiaoField] }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="total"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{ getColumnTotal(scope.row, "total", "shixiaoField") }}
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          v-if="queryParams.years > 2024"
          label="操作"
          align="center"
          width="90px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 删除 -->
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年 同比 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tongbiTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
      >
        <el-table-column label="" align="center">
          <!-- 车型 -->
          <el-table-column
            prop="carModel"
            label="车型"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <!-- 查询年同比 -->
        <el-table-column
          :label="`${Number(queryParams.years)}年同比`"
          align="center"
        >
          <!-- 同比 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.tongbiField"
            :label="item.month"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row[item.tongbiField] === 0 || scope.row[item.tongbiField]
                  ? (scope.row[item.tongbiField] * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="totalRate"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{
              (
                getColumnTotal(scope.row, "totalRate", "tongbiField") * 100
              ).toFixed(0) + "%"
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { addOrUpdateAllBrandMarketSaleChangeTrendApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      firstSearchDataTableData: [], // 前一年市场实销
      secondSearchDataTableData: [], // 当前年市场实销
      tongbiTableData: [], // 同比
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "1月",
          shixiaoField: "oneShixiao",
          tongbiField: "oneRate"
        },
        {
          month: "2月",
          shixiaoField: "twoShixiao",
          tongbiField: "twoRate"
        },
        {
          month: "3月",
          shixiaoField: "threeShixiao",
          tongbiField: "threeRate"
        },
        {
          month: "4月",
          shixiaoField: "fourShixiao",
          tongbiField: "fourRate"
        },
        {
          month: "5月",
          shixiaoField: "fiveShixiao",
          tongbiField: "fiveRate"
        },
        {
          month: "6月",
          shixiaoField: "sixShixiao",
          tongbiField: "sixRate"
        },
        {
          month: "7月",
          shixiaoField: "sevenShixiao",
          tongbiField: "sevenRate"
        },
        {
          month: "8月",
          shixiaoField: "eightShixiao",
          tongbiField: "eightRate"
        },
        {
          month: "9月",
          shixiaoField: "nineShixiao",
          tongbiField: "nineRate"
        },
        {
          month: "10月",
          shixiaoField: "tenShixiao",
          tongbiField: "tenRate"
        },
        {
          month: "11月",
          shixiaoField: "elevenShixiao",
          tongbiField: "elevenRate"
        },
        {
          month: "12月",
          shixiaoField: "twelveShixiao",
          tongbiField: "twelveRate"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.firstSearchDataTableData = [];
      data.firstSearchData?.map(item => {
        this.firstSearchDataTableData.push({ ...item, total: 0 });
      });
      this.secondSearchDataTableData = [];
      data.secondSearchData?.map(item => {
        this.secondSearchDataTableData.push({ ...item, total: 0 });
      });
      this.tongbiTableData = [];
      data.tongbi?.map(item => {
        this.tongbiTableData.push({ ...item, totalRate: 0 });
      });
      this.queryParams = { ...queryParams };
    },
    // 添加
    handleAdd() {
      this.secondSearchDataTableData.push({
        carModel: ""
      });
    },
    // 删除
    handleDelete(index) {
      this.secondSearchDataTableData.splice(index, 1);
    },
    // 获取当前行合计
    getColumnTotal(row, totalField, field) {
      let total = 0;
      this.monthList.forEach(item => {
        const value = Number(row[item[field]]);
        if (!isNaN(value)) {
          total += value;
        }
      });
      row[totalField] = total;
      return total;
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.secondSearchDataTableData[row.index][column.property] =
        this.secondSearchDataTableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          data: {
            secondSearchData: JSON.parse(
              JSON.stringify(this.secondSearchDataTableData)
            )
          }
        };
        const res = await addOrUpdateAllBrandMarketSaleChangeTrendApi(
          submitData
        );
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.secondSearchDataTableData = [];
          res.data.secondSearchData?.map(item => {
            this.secondSearchDataTableData.push({ ...item, total: 0 });
          });
          this.tongbiTableData = [];
          res.data.tongbi?.map(item => {
            this.tongbiTableData.push({ ...item, totalRate: 0 });
          });
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
